import { OnboardingStepType, OrganizationDetailFragment } from '@alice-financial/alice-sdk'
import { HealthcheckStatusResult } from '../../orgDashboard/types'
import {
  getHealthcheckStatus,
  getOnboardingStepAssignee,
  getStep,
} from '../../orgDashboard/utils/onboardingWorkflowUtils'

const STEP_TYPE = OnboardingStepType.OrderForm

export const useOrderFormStatus = (
  onboardingWorkflow?: OrganizationDetailFragment['onboardingWorkflow']
): HealthcheckStatusResult => {
  const step = getStep(onboardingWorkflow, STEP_TYPE)
  const assignee = getOnboardingStepAssignee(onboardingWorkflow, STEP_TYPE)
  const status = getHealthcheckStatus(step)

  const healthcheckTitle = 'Order form'
  const baseProperties = {
    status,
    assignee,
    healthcheckTitle,
    healthcheckType: STEP_TYPE,
    primary: healthcheckTitle,
  } as const

  if (status === 'complete') {
    return {
      secondary: 'We have received your order form',
      ...baseProperties,
    }
  }
  if (status === 'incomplete') {
    return {
      secondary: 'Agree to Terms & Conditions and sign your order form',
      ...baseProperties,
    }
  }

  return {
    secondary: 'Waiting for order form to be signed',
    ...baseProperties,
  }
}
